import { HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs font-medium whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'bg-ink-100 text-ink-700',
        brand: 'bg-brand-100 text-brand-700',
        warning: 'bg-amber-100 text-amber-700',
        success: 'bg-emerald-100 text-emerald-700',
        danger: 'bg-brand-100 text-brand-700',
        purple: 'bg-violet-100 text-violet-700',
        outline: 'border border-ink-200 bg-surface-1 text-ink-700',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
